import clsx from 'clsx'
import { Modal } from 'react-bootstrap'
import { useEffect, useMemo, useState } from 'react'
import { LoadingSpinner } from '../../../_ePulse/layout/components/LoadingSpinner'
import { usePagination, useSortBy, useTable } from 'react-table'

import moment from 'moment'
import { CommonHeader } from './components/CommonHeader'
import { CellData } from './components/CellData'
import useApi from '../../../hooks/useQuery'
import { ToastMessageContainer } from '../../../_ePulse/layout/components/ToastMessageContainer'
import { toAbsoluteUrl } from '../../../_ePulse/helpers'
import { GET_DOCUMENT_UPDATE_HISTORY } from '../../GraphQLQueries/Clinic'
import { useLocation, useNavigate } from 'react-router-dom'
const AduitTable = (Props: any) => {

  const Columns = [
    {
      Header: (props: any) => (
        <CommonHeader tableProps={props} title='Field Name' className='d-flex ms-5 text-black  ' />
      ),
      accessor: 'field',
      id: 'field',
      ell: (props: any) => <CellData tableProps={props.data[props.row.index]?.field || '-'} />,
    },
    {
      Header: (props: any) => (
        <CommonHeader tableProps={props} title='Old Value' className='d-flex ms-5 text-black  ' />
      ),
      accessor: 'oldValue',
      id: 'oldValue',
      Cell: (props: any) => (
        <CellData
          tableProps={props.data[props.row.index]?.oldValue || '-'}
        />
      ),
    },
    {
      Header: (props: any) => (
        <CommonHeader tableProps={props} title='New Value' className='d-flex ms-5 text-black  ' />
      ),
      accessor: 'newValue',
      id: 'newValue',
      Cell: (props: any) => (
        <CellData
          tableProps={props.data[props.row.index]?.newValue || '-'}
        />
      ),
    },
    {
      Header: (props: any) => (
        <CommonHeader tableProps={props} title='Updated By' className='d-flex ms-5 text-black  ' />
      ),
      accessor: 'updatedBy',
      id: 'updatedBy',
      Cell: (props: any) => (
        <CellData tableProps={props.data[props.row.index]?.updatedBy || '-'} />
      ),
    },
    {
      Header: (props: any) => (
        <CommonHeader tableProps={props} title='Date' className='d-flex ms-5 text-black  ' />
      ),
      accessor: 'createdDate',
      id: 'createdDate',
      Cell: (props: any) => (
        <CellData
          tableProps={
            props.data[props.row.index]?.createdDate
              ? moment(props.data[props.row.index]?.createdDate).format('DD/MM/YYYY')
              : '-'
          }
        />
      ),
    },
  ]

  const [listing, setListing] = useState<any>([])
  const [limit, setLimit] = useState(10)
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [pageNumber, setpageNumber] = useState(1)
  const {
    data: ListData,
    loading: loading,
    error: error,
    refetch: refetch,
  } = useApi(true, GET_DOCUMENT_UPDATE_HISTORY, {
    documentId: Props.id,
    documentType: Props.documentType,
    listFilter: {
      limit: limit,
      page: page,
    },
  })

  useEffect(() => {
    setListing(ListData?.getDocumentUpdateHistory?.data || [])
  }, [ListData])

  const data = listing
  const columns: any = useMemo(() => Columns, [])
  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useSortBy,
    usePagination
  )

  const {
    getTableProps,
    getTableBodyProps,
    headers,
    rows,
    prepareRow,
    state: { pageSize },
    setPageSize,
  }: any = tableInstance

  return (
    <div>
      <ToastMessageContainer />
      <LoadingSpinner isLoading={loading} />
      <Modal
        show={Props.modalState}
        dialogClassName='ePulse-modal ePulse-modal-70w'
        onHide={() => Props.onClose()}
        backdrop='static'
      >
        <Modal.Header closeButton>
          <span className='fs-3 fw-bold'>View History</span>
        </Modal.Header>
        <Modal.Body
          className='container-fluid d-flex flex-column p-0'
          style={{ maxHeight: '70vh', overflow: 'hidden' }}
        >
          {/* Scrollable table area */}
          <div style={{ overflowY: 'auto', flex: 1 }} className='px-4 pt-3 admin-table'>
            <table {...getTableProps()} className='table w-100'>
              <thead>
                <tr className='text-center text-dark fw-bolder fs-6 MyReactTableClass'>
                  {headers.map((column: any) => {
                    return <th>{column.render('Header')}</th>
                  })}
                </tr>
              </thead>
              <tbody className='text-black fw-normal text-center' {...getTableBodyProps()}>
                {rows.length > 0 ? (
                  rows.map((row: any, index: number) => {
                    prepareRow(row)
                    return (
                      <tr {...row.getRowProps()} className={index === 0 ? 'bg-white' : 'bg-white'}>
                        {row.cells.map((cell: any) => {
                          return (
                            <td
                              {...cell.getCellProps()}
                              className={clsx({
                                'text-end min-w-100px p-1': cell.column.id === 'actions',
                              })}
                            >
                              {cell.render('Cell')}
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })
                ) : (
                  <tr>
                    <td colSpan={7}>
                      <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                        No matching records found
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Sticky pagination — always visible at bottom */}
          {listing.length > 0 && (
            <div className='pagination px-4 py-2 border-top justify-content-between' style={{ flexShrink: 0 }}>
              <div className='page-show'>
                <span>Show Entries</span>
                <select
                  className='ms-2 ePulse-pagination-dropdown'
                  value={limit}
                  onChange={(e) => {
                    setLimit(Number(e.target.value))
                    setpageNumber(1)
                    refetch({ limit: parseInt(e.target.value) })
                  }}
                >
                  {[10, 20, 30, 40, 50, 100, 500].map((size) => (
                    <option key={size} value={size}>
                      {size}
                    </option>
                  ))}
                </select>
              </div>
              <div className='page-num'>
                <button
                  className={
                    pageNumber === 1
                      ? 'ePulse-pagination-button'
                      : clsx('ePulse-pagination-button text-white')
                  }
                  onClick={() => {
                    setpageNumber(pageNumber - 1)
                    refetch({ page: pageNumber - 1, limit: limit })
                  }}
                  disabled={pageNumber === 1}
                >
                  <img
                    alt='Previous'
                    src={toAbsoluteUrl('/media/icons/duotune/arrows/arr022.svg')}
                  />
                </button>
                <span className='mx-3'>
                  Page{' '}
                  <strong>
                    {pageNumber} of {totalPages}
                  </strong>{' '}
                </span>
                <button
                  className={
                    pageNumber === totalPages
                      ? 'ePulse-pagination-button'
                      : clsx('ePulse-pagination-button text-white')
                  }
                  onClick={() => {
                    setpageNumber(pageNumber + 1)
                    refetch({ page: pageNumber + 1, limit: limit })
                  }}
                  disabled={pageNumber === totalPages}
                >
                  <img alt='Next' src={toAbsoluteUrl('/media/icons/duotune/arrows/arr023.svg')} />
                </button>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default AduitTable
